class Logger {
  #enableLogs = false;

  constructor(options = { debug: false }) {
    this.#enableLogs = options?.debug === true;
  }

  log(...args) {
    if (!this.#enableLogs) {
      return;
    }
    console.log(...args);
  }

  warn(...args) {
    if (!this.#enableLogs) {
      return;
    }
    console.warn(...args);
  }

  error(...args) {
    if (!this.#enableLogs) {
      return;
    }
    console.error(...args);
  }

  info(...args) {
    if (!this.#enableLogs) {
      return;
    }
    console.info(...args);
  }
}

export default Logger;

